<template>
    <a :href="link" :target="target || '_self'">
        <div
            class="group relative cursor-pointer overflow-hidden bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl sm:mx-auto sm:max-w-sm sm:rounded-lg sm:px-10">
            <span
                class="absolute top-10 z-0 h-20 w-20 rounded-full bg-primary-200 transition-all duration-300 group-hover:scale-[10]"></span>
            <div class="relative z-10 mx-auto max-w-md">
                <span
                    class="grid h-20 w-20 place-items-center rounded-full bg-primary-100 transition-all duration-300 group-hover:bg-sky-400">
                    <icon name="{{ iconName }}" class="mx-auto fill-white w-12 h-12 group-hover:fill-white" />
                </span>
                <div
                    class="space-y-6 pt-5 text-base leading-7 text-gray-600 transition-all duration-300 group-hover:text-white/90">
                    <p><strong>{{ title }}</strong></p>
                    <p>{{ text }}</p>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import { provide } from 'vue'

export default {
    components: {
        Icon,
    },
    props: {
        title: String,
        iconName: String,
        text: String,
        link: String,
        target: String,
    },
    setup(props) {
        provide('name', props.iconName);
    }
}
</script>